var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.2 24.7",
    style: {
      enableBackground: "new 0 0 33.2 24.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M31.9,0.2l0,0.3L31.9,0.2l-30.4,0c-0.7,0-1.2,0.5-1.2,1.2v21.9c0,0.7,0.5,1.2,1.2,1.2h30.3 c0.7,0,1.2-0.5,1.2-1.2V1.4C33,0.8,32.5,0.2,31.9,0.2z M16.6,11.2L5.5,2.6h22.2L16.6,11.2z M30.5,3.7v18.4H2.7V3.6L15.9,14 c0.4,0.3,0.9,0.3,1.3,0L30.5,3.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.89fe2984.svg";
export { ForwardRef as ReactComponent };